
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as consentActions from '../../actions/consentActions';
import {
    Grid,
    Row,
    Col,
    Image,
    FormGroup,
    FormControl,
    ControlLabel,
    Panel,
    PanelGroup,
} from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from "../../components/CustomButton/CustomButton.jsx";
import Switch from "react-bootstrap-switch";
import Checkbox from '../../components/CustomCheckbox/CustomCheckbox.jsx';
import rest from "../../API/api";
import ReactTable from "react-table";

class AddConsentForm extends Component {
    constructor(props) {
        super(props);
        this._grabUserInput = this._grabUserInput.bind(this);
        this._saveConsent = this._saveConsent.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.loadArtists = this.loadArtists.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.handleAgeChange = this.handleAgeChange.bind(this);
        this.handleCameraChange = this.handleCameraChange.bind(this);
        this.handlePhotoRequired = this.handlePhotoRequired.bind(this);
        this.handleAskRelation = this.handleAskRelation.bind(this);
        this.handleEnableNotary = this.handleEnableNotary.bind(this);
        this.handleRequireName = this.handleRequireName.bind(this);
        this.handleRequireEmail = this.handleRequireEmail.bind(this);
        this.handleRequireAddress = this.handleRequireAddress.bind(this);
        this.handleRequirePhone = this.handleRequirePhone.bind(this);
        this.handleRequireNationality = this.handleRequireNationality.bind(this);
        this.handleRequireGender = this.handleRequireGender.bind(this);
        this._fileChangedHandler =this._fileChangedHandler.bind(this);
        this.state = {

            _id: "",
            Enabled: false,
            Name: "",
            TitleImage: "",
            TitleImagePublicId: "",
            Header: "",
            AfterSubmit: "",
            Company: "",
            EmailTo: "",
            EmailFrom: "",
            EmailSubject: "",
            EmailText: "",
            EnableCamera: true,
            PhotoRequired: true,
            AgeLimit: "",
            AskRelation: false,
            EnableNotary: false,
            ParentHeader: "",
            ConsentFooter: "",
            RequireName: false,
            RequireAddress: false,
            RequireEmail: false,
            RequirePhone: false,
            RequireNationality: false,
            RequireGender: false,
            IncludedArtists: [],
            IncludedClauses: [],
            dataIncludedClauses: [],
            dataIncludedArtists: [],
            dataAllClauses: [],
            dataAllArtists: [],
            imageChanged: false,

            /*
            Enabled: this.props.consent.Enabled,
            Name: this.props.consent.Name,
            Header: this.props.consent.Header,
            AfterSubmit: this.props.consent.AfterSubmit,
            TitleImage: this.props.consent.TitleImage,
            TitleImagePublicId: this.props.consent.TitleImagePublicId,
            Company:  this.props.consent.Company,
            EmailTo:  this.props.consent.EmailTo,
            EmailFrom: this.props.consent.EmailFrom,
            EmailSubject: this.props.consent.EmailSubject,
            EmailText: this.props.consent.EmailText,
            EnableCamera: this.props.consent.EnableCamera,
            PhotoRequired: this.props.consent.PhotoRequired,
            AgeLimit: this.props.consent.AgeLimit,
            AskRelation: this.props.consent.AskRelation ,
            EnableNotary: this.props.consent.EnableNotary,
            ParentHeader: this.props.consent.ParentHeader,
            ConsentFooter: this.props.consent.ConsentFooter,
            RequireName: this.props.consent.RequireName,
            RequireAddress: this.props.consent.RequireAddress,
            RequireEmail: this.props.consent.RequireEmail,
            RequirePhone: this.props.consent.RequirePhone,
            RequireNationality: this.props.consent.RequireNationality,
            RequireGender: this.props.consent.RequireGender,
            dataClauses: this.props.consent.IncludedClauses,
            dataArtists: this.props.consent.IncludedArtists,
            */

            EnabledError: null,
            NameError: null,
            HeaderError: null,
            AfterSubmitError: null,
            TitleImageError: null,
            CompanyError: null,
            EmailToError: null,
            EmailFromError: null,
            EmailSubjectError: null,
            EmailTextError: null,
            AgeLimitError: null,
            ParentHeaderError: null,


        };
        this.loadArtists(this.props.userLoggedIn[0]);
        this.loadClauses(this.props.userLoggedIn[0]);
    }

    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }


    _fileChangedHandler = event => {
        event.preventDefault();

        let reader = new FileReader();
        let file = event.target.files[0];

        reader.onloadend = () => {
            this.setState({
                TitleImage: reader.result,
            });
        };
        reader.readAsDataURL(file);
        //console.log(event.target.files[0]);
    };

    handleSwitch(elem, state) {
        this.setState({Enabled: state});
        /*
        console.log('handleSwitch. elem:', elem);
        console.log('name:', elem.props.name);
        console.log('new state:', state);*/
    }



    handleAgeChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({ AgeLimit: ReactDOM.findDOMNode(this.selectAge).value });
    };

    handleSubmitChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({ AfterSubmit: ReactDOM.findDOMNode(this.selectSubmit).value });
    };

   handleCameraChange = () => {
        this.setState({
            EnableCamera: !this.state.EnableCamera,
        });
    };

    handlePhotoRequired = () => {
        this.setState({
            PhotoRequired: !this.state.PhotoRequired,
        });
    };

    handleAskRelation = () => {
        this.setState({
            AskRelation: !this.state.AskRelation,
        });
    };

    handleEnableNotary = () => {
        this.setState({
            EnableNotary: !this.state.EnableNotary,
        });
    };

    handleRequireName = () => {
        this.setState({
            RequireName: !this.state.RequireName,
        });
    };

    handleRequireEmail = () => {
        this.setState({
            RequireEmail: !this.state.RequireEmail,
        });
    };

    handleRequireAddress = () => {
        this.setState({
            RequireAddress: !this.state.RequireAddress,
        });
    };

    handleRequirePhone = () => {
        this.setState({
            RequirePhone: !this.state.RequirePhone,
        });
    };

    handleRequireNationality = () => {
        this.setState({
            RequireNationality: !this.state.RequireNationality,
        });
    };

    handleRequireGender = () => {
        this.setState({
            RequireGender: !this.state.RequireGender,
        });
    };

    loadArtists(tenant) {
        let tempURL = rest.artists + '/' + tenant._id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                //debugger;
                // turn the JSON into a string then into an JS array
                let myArtists = JSON.parse(JSON.stringify(data));
                this.setState({
                    dataArtists: myArtists.map(artist => {
                        return {
                            id: artist._id,
                            Name: artist.Name,
                            LiscNumber: artist.LiscNumber,
                            Included: "Not Included",

                            actions: (
                                // we've added some custom button actions
                                <div className="actions-right">
                                    {/* use this button to remove the data row */}
                                    <Button
                                        onClick={async () => {
                                            var data = this.state.dataArtists;
                                            data.find((o, i) => {
                                                if (o.id === artist._id) {
                                                    if(o.Included === "Not Included")
                                                        o.Included = "Included";
                                                }
                                            });
                                            this.setState({dataArtists: data});
                                        }}
                                        bsStyle="info"
                                        simple
                                        icon
                                    >
                                        <i className="fa fa-plus"/>
                                    </Button>{" "}
                                    <Button
                                        onClick={async () => {
                                            var data = this.state.dataArtists;
                                            data.find((o, i) => {
                                                if (o.id === artist._id) {
                                                    if(o.Included === "Included")
                                                        o.Included = "Not Included";
                                                }
                                            });
                                            this.setState({dataArtists: data});
                                        }}
                                        bsStyle="danger"
                                        simple
                                        icon
                                    >
                                        <i className="fa fa-minus"/>
                                    </Button>{" "}
                                    {this.state.alert}
                                </div>
                            )
                        }
                    })
                })
            })
            .catch(error => console.error(error));
    }

    loadClauses(tenant) {
        let tempURL = rest.clauses + '/' + tenant._id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                //debugger;
                // turn the JSON into a string then into an JS array
                let myClauses = JSON.parse(JSON.stringify(data));
                this.setState({
                    dataClauses: myClauses.map(clause=> {
                        return {
                            id: clause._id,
                            Type: clause.Type,
                            Required: clause.Required,
                            Title: clause.Title,
                            Text: clause.Text,
                            Included: "Not Included",

                            actions: (
                                // we've added some custom button actions
                                <div className="actions-right">
                                    {/* use this button to add a record */}
                                    <Button
                                        onClick={async () => {
                                        var data = this.state.dataClauses;
                                        var found_it = false;
                                        data.find((o, i) => {
                                            if ((o.id === clause._id) && (!found_it)){
                                                found_it = true;
                                                if(i !== 0) {
                                                    var newData = array_move(data, i, i - 1);
                                                    this.setState({dataClauses: newData});
                                                }
                                            }
                                        });
                                    }}
                                        bsStyle="info"
                                        simple
                                        icon
                                    >
                                        <i className="fa fa-arrow-up "/>
                                    </Button>{" "}
                                    {/* use this button to add a edit kind of action */}
                                    <Button
                                        onClick={async () => {
                                            var data = this.state.dataClauses;
                                            var found_it = false;
                                            data.find((o, i) => {
                                                //Make sure I haven't found it already
                                                if ((o.id === clause._id) && (!found_it)){
                                                    found_it = true;
                                                    //Make Sure I am not at the end of the Array
                                                    if((i+1) !== data.length) {
                                                        var newData = array_move(data, i, i + 1);
                                                        this.setState({dataClauses: newData});
                                                    }
                                                }
                                            });
                                        }}
                                        bsStyle="info"
                                        simple
                                        icon
                                    >
                                        <i className="fa fa-arrow-down "/>
                                    </Button>{" "}
                                    {/* use this button to remove the data row */}
                                    <Button
                                        onClick={async () => {
                                            var data = this.state.dataClauses;
                                            data.find((o, i) => {
                                                if (o.id === clause._id) {
                                                    if(o.Included === "Not Included")
                                                        o.Included = "Included";
                                                }
                                            });
                                            this.setState({dataClauses: data});
                                        }}
                                        bsStyle="info"
                                        simple
                                        icon
                                    >
                                        <i className="fa fa-plus"/>
                                    </Button>{" "}
                                    <Button
                                        onClick={async () => {
                                            var data = this.state.dataClauses;
                                            data.find((o, i) => {
                                                if (o.id === clause._id) {
                                                    if(o.Included === "Included")
                                                        o.Included = "Not Included";
                                                }
                                            });
                                            this.setState({dataClauses: data});
                                        }}
                                        bsStyle="danger"
                                        simple
                                        icon
                                    >
                                        <i className="fa fa-minus"/>
                                    </Button>{" "}
                                    {this.state.alert}
                                </div>
                            )
                        }
                    })
                })
            })
            .catch(error => console.error(error));
    }

    isValidated() {
        //check each required field for validation
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.state.Name=== ""
            ? this.setState({
                NameError: (
                    <small className="text-danger">
                        Please provide a name for this consent form.
                    </small>
                )
            })
            : this.setState({ NameError: null });
        var name = this.state.Name !== "";

        this.state.Header=== ""
            ? this.setState({
                HeaderError: (
                    <small className="text-danger">
                        Please provide a name for this consent form.
                    </small>
                )
            })
            : this.setState({ HeaderError: null });
        var header= this.state.Header !== "";

        ((this.state.AfterSubmit === "") || (this.state.AfterSubmit === "Where do we go after submit?"))
            ? this.setState({
                AfterSubmitError: (
                    <small className="text-danger">
                        Please provide what to do after the form has been submitted.
                    </small>
                )
            })
            : this.setState({ AfterSubmitError: null });
        var after_submit = ((this.state.AfterSubmit !== "") && (this.state.AfterSubmit !== "Where do we go after submit?"));

        this.state.Company=== ""
            ? this.setState({
                CompanyError: (
                    <small className="text-danger">
                        Please provide a company name for this consent form.
                    </small>
                )
            })
            : this.setState({ CompanyError: null });
        var company= this.state.Company !== "";

        re.test(this.state.EmailTo) === false
            ? this.setState({
                EmailToError: (
                    <small className="text-danger">
                        The To Email is required and format should be <i>john@doe.com</i>.
                    </small>
                )
            })
            : this.setState({ EmailToError: null });

        re.test(this.state.EmailFrom) === false
            ? this.setState({
                EmailFromError: (
                    <small className="text-danger">
                        The From Email is required and format should be <i>john@doe.com</i>.
                    </small>
                )
            })
            : this.setState({ EmailFromError: null });

        this.state.EmailSubject=== ""
            ? this.setState({
                EmailSubjectError: (
                    <small className="text-danger">
                        Please provide the email subject for this consent form.
                    </small>
                )
            })
            : this.setState({ EmailSubjectError: null });
        var email_subject= this.state.EmailText !== "";

        this.state.EmailText=== ""
            ? this.setState({
                EmailTextError: (
                    <small className="text-danger">
                        Please provide the email text for this consent form.
                    </small>
                )
            })
            : this.setState({ EmailTextError: null });
        var email_text= this.state.EmailText !== "";

        ((this.state.AgeLimit === "") || (this.state.AgeLimit === "Type of Age Consent?"))
            ? this.setState({
                AgeLimitError: (
                    <small className="text-danger">
                        Please provide an Age Consent Type for this consent clause.
                    </small>
                )
            })
            : this.setState({ AgeLimitError: null });
        var age = ((this.state.AgeLimit !== "") && (this.state.AgeLimit !== "Type of Age Consent?"));

        this.state.ParentHeader=== ""
            ? this.setState({
                ParentHeaderError: (
                    <small className="text-danger">
                        Please provide a Parent Header for parent consent processing.
                    </small>
                )
            })
            : this.setState({ ParentHeaderError: null });
        var parent_header= this.state.ParentHeader !== "";

        var valid = (name && header && after_submit && company && re.test(this.state.EmailTo) && re.test(this.state.EmailFrom) && email_subject && email_text && age && parent_header);
        if(valid)
            return valid;
    }

    successAlert(saved){
        //Setup the alert and use the context to route to the Tenants once record is saved.
        if(saved) {
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        title="Consent added successfully!"
                        style={{display: "block"}}
                        onConfirm={() => this.context.router.history.push("/Consents")}
                        onCancel={() => this.context.router.history.push("/Consents")}
                        confirmBtnBsStyle="info"
                    >
                    </SweetAlert>
                )
            });
        }
        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Missing required fields, please correct field values and try again!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                    </SweetAlert>
                )
            });
        }
    }

    _grabUserInput() {
        //Lets loop the artists and clauses arrays and copy any records that are included in this consent form
        var includedArtists = [];
        var includedClauses = [];
        this.state.dataArtists.forEach(function(artist, index, artists) {
            if(artist.Included === "Included")
                includedArtists.push({
                    ArtistId: artist.id,
                    Name: artist.Name,
                    LiscNumber: artist.LiscNumber,
                    Included: artist.Included
                });
        });
        this.state.dataClauses.forEach(function(clause, index, clauses) {
            if(clause.Included === "Included")
                includedClauses.push({
                    ClauseId: clause.id,
                    Type: clause.Type,
                    Required: clause.Required,
                    Title: clause.Title,
                    Text: clause.Text,
                    Included: clause.Included
                });
        });
        return {
            Enabled: this.state.Enabled,
            Name: document.getElementById('Name').value,
            //TitleImage: binEncode(this.state.TitleImage.replace(/^data:image\/(png|jpg);base64,/, "")),
            TitleImage: this.state.TitleImage,
            TitleImagePublicId:"",
            Header: document.getElementById('Header').value,
            AfterSubmit: ReactDOM.findDOMNode(this.selectSubmit).value,
            Company: document.getElementById('Company').value,
            EmailTo: document.getElementById('EmailTo').value,
            EmailFrom: document.getElementById('EmailFrom').value,
            EmailSubject: document.getElementById('EmailSubject').value,
            EmailText: document.getElementById('EmailText').value,
            EnableCamera: this.state.EnableCamera,
            PhotoRequired: this.state.PhotoRequired,
            AgeLimit: ReactDOM.findDOMNode(this.selectAge).value,
            AskRelation: this.state.AskRelation,
            EnableNotary: this.state.EnableNotary,
            ParentHeader: document.getElementById('ParentHeader').value,
            ConsentFooter: document.getElementById('ConsentFooter').value,
            RequireName: this.state.RequireName,
            RequireEmail: this.state.RequireEmail,
            RequireAddress: this.state.RequireAddress,
            RequirePhone: this.state.RequirePhone,
            RequireNationality: this.state.RequireNationality,
            RequireGender: this.state.RequireGender,
            IncludedArtists: includedArtists,
            IncludedClauses: includedClauses
        };
    }

    _saveConsent(event) {
        event.preventDefault();
        if (this.isValidated()) {
            let userInput = this._grabUserInput();
            //Pass the current logged in user information and the new consent record array
            this.props.consentActions.addConsent(this.props.userLoggedIn[0], userInput);
            this.successAlert(true);
        }
        else
            this.successAlert(false);

    }


    render() {
        //debugger;
        if ((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription)) {
            return (
                <div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/matrix.jpg") + ")" }}>
                    <Grid fluid>
                        <PanelGroup
                            id="panels"
                            ref="panels"
                            defaultActiveKey="8"
                            onClick={() => this.forceUpdate()}
                        >
                            <Panel eventKey="1">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>General Consent Information<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <Card
                                        content={
                                            <div>
                                                <legend>Add: Consent Information</legend>
                                                <Row>
                                                    <Col md={2} mdOffset={1}>
                                                        <FormGroup>
                                                            <ControlLabel>Enabled:  </ControlLabel>
                                                            <Switch
                                                                onText="On"
                                                                offText="Off"
                                                                onChange={(el, state) => this.handleSwitch(el, state)}
                                                                name="enabled"
                                                                id="Enabled"
                                                                value={this.state.Enabled}
                                                            />
                                                            <span className="text-danger">*</span>
                                                            {this.state.EnabledError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <ControlLabel>Consent Form Name <span className="text-danger">*</span></ControlLabel>
                                                            <FormControl
                                                                id="Name"
                                                                type="text"
                                                                name="name"
                                                                placeholder="My Consent Name"
                                                                value={this.state.Name}
                                                                onChange={event => this.setState({Name: event.target.value})}
                                                            />
                                                            {this.state.NameError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={7} mdOffset={1} >
                                                        <FormGroup controlId="formControlsTextarea">
                                                            <ControlLabel>Consent Form Header <span className="text-danger">*</span></ControlLabel>
                                                            <FormControl
                                                                id="Header"
                                                                rows="5"
                                                                name="header"
                                                                componentClass="textarea"
                                                                placeholder="ex: My Consent Form Header"
                                                                bsClass="form-control"
                                                                value={this.state.Header}
                                                                onChange={event => this.setState({Header: event.target.value})}
                                                            />
                                                            {this.state.HeaderError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={5} mdOffset={1}>
                                                        <FormGroup>
                                                            <ControlLabel>After Submit <span className="text-danger">*</span></ControlLabel>
                                                            <FormControl componentClass="select"
                                                                         placeholder="Where do we go after submit?"
                                                                         ref={select => { this.selectSubmit = select }}
                                                                         onChange={this.handleSubmitChange}
                                                                         value={this.state.AfterSubmit}
                                                            >
                                                                <option value="Where do we go after submit?">Where do we go after submit?</option>
                                                                <option value="Same">Refresh - Stay on this form</option>
                                                                <option value="Index">Show list of your consents</option>
                                                            </FormControl>
                                                            {this.state.AfterSubmitError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={3} mdOffset={1} xs={5} xsOffset={1}>
                                                        <FormGroup>
                                                            <ControlLabel>
                                                               Consent Title Image
                                                            </ControlLabel>
                                                            <input style={{display:'none'}}
                                                                   type="file"
                                                                   onChange={this._fileChangedHandler}
                                                                   ref={fileInput => this.fileInput = fileInput}
                                                                   id="consentImage"
                                                                   name="consentImage"

                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={1} mdOffset={1} xs={1} xsOffset={1}>
                                                        <FormGroup>
                                                            <Button bsStyle="info" fill onClick={() => this.fileInput.click()}>
                                                                Pick an Image
                                                            </Button>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3} mdOffset={1} xs={4} xsOffset={4}>
                                                        <FormGroup>
                                                            <ControlLabel>
                                                                Preview
                                                            </ControlLabel>
                                                            <Image src={this.state.TitleImage} responsive />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                            <Panel eventKey="2">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>Included Artists<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <Card
                                        content={
                                            <div>
                                                <legend>Add: Artists</legend>
                                                <Row>
                                                    <Col md={11} mdOffset={1}>
                                                        <ReactTable
                                                            data={this.state.dataArtists}
                                                            filterable
                                                            columns={[
                                                                {
                                                                    Header: "Name",
                                                                    accessor: "Name",
                                                                    sortable: true,
                                                                    filterable: true
                                                                },
                                                                {
                                                                    Header: "License Number",
                                                                    accessor: "LiscNumber",
                                                                    sortable: true,
                                                                    filterable: true
                                                                },
                                                                {
                                                                    Header: "Included in Form",
                                                                    accessor: "Included",
                                                                    sortable: true,
                                                                    filterable: true
                                                                },
                                                                {
                                                                    Header: "Actions",
                                                                    accessor: "actions",
                                                                    sortable: false,
                                                                    filterable: false
                                                                }
                                                            ]}
                                                            defaultPageSize={5}
                                                            showPaginationTop
                                                            showPaginationBottom={false}
                                                            className="-striped -highlight"
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                            <Panel eventKey="3">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>Email Settings<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <Card
                                        content={
                                            <div>
                                                <legend>Add: Email Settings</legend>
                                                <Row>
                                                    <Col md={5} mdOffset={1}>
                                                        <FormGroup>
                                                            <ControlLabel>Company Name<span className="text-danger">*</span></ControlLabel>
                                                            <FormControl
                                                                id="Company"
                                                                type="text"
                                                                name="company"
                                                                placeholder="ex: My Company"
                                                                value={this.state.Company}
                                                                onChange={event => this.setState({Company: event.target.value})}
                                                            />
                                                            {this.state.CompanyError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={5} mdOffset={1}>
                                                        <FormGroup>
                                                            <ControlLabel>Email To<span className="text-danger">*</span></ControlLabel>
                                                            <FormControl
                                                                id="EmailTo"
                                                                type="text"
                                                                name="email_to"
                                                                placeholder="ex: joe@doe.com"
                                                                value={this.state.EmailTo}
                                                                onChange={event => this.setState({EmailTo: event.target.value})}
                                                            />
                                                            {this.state.EmailToError}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={5}>
                                                        <FormGroup>
                                                            <ControlLabel>Email From<span className="text-danger">*</span></ControlLabel>
                                                            <FormControl
                                                                id="EmailFrom"
                                                                type="text"
                                                                name="email_from"
                                                                placeholder="ex: joe@doe.com"
                                                                value={this.state.EmailFrom}
                                                                onChange={event => this.setState({EmailFrom: event.target.value})}
                                                            />
                                                            {this.state.EmailFromError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                <Col md={5} mdOffset={1}>
                                                    <FormGroup>
                                                        <ControlLabel>Email Subject<span className="text-danger">*</span></ControlLabel>
                                                        <FormControl
                                                            id="EmailSubject"
                                                            type="text"
                                                            name="email_subject"
                                                            placeholder="ex: Some Email Subject"
                                                            value={this.state.EmailSubject}
                                                            onChange={event => this.setState({EmailSubject: event.target.value})}
                                                        />
                                                        {this.state.EmailSubjectError}
                                                    </FormGroup>
                                                </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={5} mdOffset={1} >
                                                        <FormGroup controlId="formControlsTextarea">
                                                            <ControlLabel>Email Text <span className="text-danger">*</span></ControlLabel>
                                                            <FormControl
                                                                id="EmailText"
                                                                rows="5"
                                                                name="email_text"
                                                                componentClass="textarea"
                                                                placeholder="ex: Some Email Text"
                                                                bsClass="form-control"
                                                                value={this.state.EmailText}
                                                                onChange={event => this.setState({EmailText: event.target.value})}
                                                            />
                                                            {this.state.EmailTextError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                            <Panel eventKey="4">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>Camera Settings<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <Card
                                        content={
                                            <div>
                                                <legend>Add: Camera and Photo Settings</legend>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <Checkbox
                                                                number="camera"
                                                                label="Enable Camera?"
                                                                value={this.state.EnableCamera}
                                                                onChange={this.handleCameraChange}
                                                                checked={this.state.EnableCamera}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <Checkbox
                                                                number="photo"
                                                                label="Photo Required?"
                                                                value={this.state.PhotoRequired}
                                                                onChange={this.handlePhotoRequired}
                                                                checked={this.state.PhotoRequired}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                            <Panel eventKey="5">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>Age of Consent Settings<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <Card
                                        content={
                                            <div>
                                                <legend>Add: Age of Consent Settings</legend>
                                                <Row>
                                                    <Col md={5} mdOffset={1}>
                                                        <FormGroup>
                                                            <ControlLabel>Consent Age <span className="text-danger">*</span></ControlLabel>
                                                            <FormControl componentClass="select"
                                                                         placeholder="Type of Age Consent?"
                                                                         ref={select => { this.selectAge = select }}
                                                                         onChange={this.handleAgeChange}
                                                                         value={this.state.AgeLimit}
                                                            >
                                                                <option value="Type of Age Consent?">Type of Age Consent?</option>
                                                                <option value="No Age Limit">No Age Limit</option>
                                                                <option value="Under 16 needs Parent">Under 16 needs Parent</option>
                                                                <option value="Under 18 needs Parent">Under 18 needs Parent</option>
                                                                <option value="18 and over, no exceptions">18 and over, no exceptions</option>
                                                                <option value="16 and over, no exceptions">16 and over, no exceptions</option>
                                                            </FormControl>
                                                            {this.state.AgeLimitError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                    <Row>
                                                        <Col md={3} mdOffset={1}>
                                                            <FormGroup>
                                                                <Checkbox
                                                                    number="relation"
                                                                    label="Ask Relation?"
                                                                    value={this.state.AskRelation}
                                                                    onChange={this.handleAskRelation}
                                                                    checked={this.state.AskRelation}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                {/* Lets hide this for now since its not needed at this time
                                                    <Row>
                                                        <Col md={3} mdOffset={1}>
                                                            <FormGroup>
                                                                <Checkbox
                                                                    number="notary"
                                                                    label="Enable Notary?"
                                                                    value={this.state.EnableNotary}
                                                                    onChange={this.handleEnableNotary}
                                                                    checked={this.state.EnableNotary}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row> */ }
                                                <Row>
                                                    <Col md={5} mdOffset={1} >
                                                        <FormGroup controlId="formControlsTextarea">
                                                            <ControlLabel>Parent Header <span className="text-danger">*</span></ControlLabel>
                                                            <FormControl
                                                                id="ParentHeader"
                                                                rows="5"
                                                                name="parent_header"
                                                                componentClass="textarea"
                                                                placeholder="ex: Parent Header text"
                                                                bsClass="form-control"
                                                                value={this.state.ParentHeader}
                                                                onChange={event => this.setState({ParentHeader: event.target.value})}
                                                            />
                                                            {this.state.ParentHeaderError}
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                            <Panel eventKey="6">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>Included Clauses and Footer<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <Card
                                        content={
                                            <div>
                                                <legend>Add: Clauses and Footer</legend>
                                                <Row>
                                                    <Col md={11} mdOffset={1}>
                                                        <ReactTable
                                                            data={this.state.dataClauses}
                                                            filterable
                                                            columns={[
                                                                {
                                                                    Header: "Title",
                                                                    accessor: "Title"
                                                                },
                                                                {
                                                                    Header: "Required",
                                                                    accessor: "Required"
                                                                },
                                                                {
                                                                    Header: "Type",
                                                                    accessor: "Type"
                                                                },
                                                                {
                                                                    Header: "Text",
                                                                    accessor: "Text"
                                                                },
                                                                {
                                                                    Header: "Included in From",
                                                                    accessor: "Included"
                                                                },
                                                                {
                                                                    Header: "Actions",
                                                                    accessor: "actions",
                                                                    sortable: false,
                                                                    filterable: false
                                                                }
                                                            ]}
                                                            defaultPageSize={5}
                                                            showPaginationTop
                                                            showPaginationBottom={false}
                                                            className="-striped -highlight"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={5} mdOffset={1} >
                                                        <FormGroup controlId="formControlsTextarea">
                                                            <ControlLabel>Consent Footer </ControlLabel>
                                                            <FormControl
                                                                id="ConsentFooter"
                                                                rows="5"
                                                                name="consent_footer"
                                                                componentClass="textarea"
                                                                placeholder="ex: Consent Footer text"
                                                                bsClass="form-control"
                                                                value={this.state.ConsentFooter}
                                                                onChange={event => this.setState({ConsentFooter: event.target.value})}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                            <Panel eventKey="7">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>Required User Fields<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    <Card
                                        content={
                                            <div>
                                                <legend>Add: Required User Fields</legend>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <Checkbox
                                                                number="name"
                                                                label="Require Name?"
                                                                value={this.state.RequireName}
                                                                onChange={this.handleRequireName}
                                                                checked={this.state.RequireName}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <Checkbox
                                                                number="address"
                                                                label="Require Address?"
                                                                value={this.state.RequireAddress}
                                                                onChange={this.handleRequireAddress}
                                                                checked={this.state.RquireAddress}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                <Col md={3} mdOffset={1}>
                                                    <FormGroup>
                                                        <Checkbox
                                                            number="email"
                                                            label="Require Email?"
                                                            value={this.state.RequireEmail}
                                                            onChange={this.handleRequireEmail}
                                                            checked={this.state.RequireEmail}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <Checkbox
                                                                number="phone"
                                                                label="Require Phone?"
                                                                value={this.state.RequirePhone}
                                                                onChange={this.handleRequirePhone}
                                                                checked={this.state.RequirePhone}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <Checkbox
                                                                number="nationality"
                                                                label="Require Nationality?"
                                                                value={this.state.RequireNationality}
                                                                onChange={this.handleRequireNationality}
                                                                checked={this.state.RequireNationality}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={3} mdOffset={1}>
                                                        <FormGroup>
                                                            <Checkbox
                                                                number="gender"
                                                                label="Gender"
                                                                value={this.state.RequireGender}
                                                                onChange={this.handleRequireGender}
                                                                checked={this.state.RequireGender}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                            <Panel eventKey="7">
                                <Panel.Heading>
                                    <Panel.Title style={{ height: 40, borderColor: 'gray', borderWidth: 1, color : "blue", textAlign:'center'}}
                                                 toggle>Validate and Save Consent Form<b className="caret" />
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    <Card
                                        content={
                                            <div>
                                               <legend>Validate and Save all Fields</legend>
                                                <Row>
                                                    <Col md={5} mdOffset={1} xs={5} xsOffset={1}>
                                                        <Button bsStyle="info" pullRight fill wd onClick={this._saveConsent}>
                                                            Save
                                                        </Button>
                                                    </Col>
                                                    <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                                        <Button bsStyle="info" pullRight fill wd onClick={ async () => {
                                                            let tURL = "/consents";
                                                            await this.context.router.history.push(tURL);
                                                        }}>
                                                            Cancel
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    />
                                    {this.state.alert}
                                </Panel.Body>
                            </Panel>
                        </PanelGroup>
                    </Grid>
                </div>
            );
        }
        else {
            alert("You must be logged in and have an active subscription to access this page!");
            this.context.router.history.push("/pages/login-page");
            return(null);
        }
    }
}

AddConsentForm.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    consent: PropTypes.object.isRequired
};

function binEncode(data) {
    var binArray = [];
    var datEncode = "";

    for (let i=0; i < data.length; i++) {
        binArray.push(data[i].charCodeAt(0).toString(2));
    }
    for (let j=0; j < binArray.length; j++) {
        var pad = padding_left(binArray[j], '0', 8);
        datEncode += pad + ' ';
    }
    function padding_left(s, c, n) { if (! s || ! c || s.length >= n) {
        return s;
    }
        var max = (n - s.length)/c.length;
        for (var i = 0; i < max; i++) {
            s = c + s; } return s;
    }
    console.log(binArray);
}

function array_move(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing purposes
}

function mapStateToProps(state, ownProps) {
    return {
        userLoggedIn: state.userLoggedIn,
        consent: state.consent,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        consentActions: bindActionCreators(consentActions, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddConsentForm);



// WEBPACK FOOTER //
// ./src/views/Forms/AddConsent.jsx